const colors = {
  common: {
    white: "#fff",
    black: "#000",
  },
  primary: {
    main: "#1a237e",
    // light: "#bebbbb",
    // dark:"#444054",
    //main: "#281E50",
    light: "#f4f4f7",
    dark: "#252525",
    shadow: "0px 5px 20px 0px rgba(0,0,0,0.07)",
    red: "#fb434f",
  },
  secondary: {
    light: "#E3F6FF",
    // main:"#d7d5d5",
    main: "#1d1d1d",
    dark: "#3f51b5",
  },
  success: {
    light: "#81c784",
    main: "#4caf50",
    dark: "#388e3c",
    contrastText: "#fff",
  },
  warning: {
    light: "#ffb74d",
    main: "#ff9800",
    dark: "#f57c00",
    contrastText: "#fff",
  },
  text: { main: "#f2f2f4", secondary: "#2E3A59", grey: "#A2A2A2" },
  background: {
    primary: "#E5E7EB",
    primaryLight: "#F7F7F7",
    secondary: "#F3D01C",
  },
  greenCyan: "#A3E8C3",
  darkCyan: "#58BD87",
  grey: {
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#737373",
    600: "#696969",
    700: "#242736",
    800: "#191919",
  },
  red: {
    900: "#FD0606",
  },
};

export default colors;
